module.exports = __webpack_public_path__ + "img/web-design.2d9944aa.svg";